import { useContext } from 'react';
import { createContext } from 'react';

import { ReviewsProps } from '../@types/ReviewsProps';

export const ReviewsContext = createContext<ReviewsProps>({} as ReviewsProps);

ReviewsContext.displayName = 'Reviews';

const ReviewsProvider = (props: ReviewsProps) => (
	<ReviewsContext.Provider value={props}>{props.children}</ReviewsContext.Provider>
);

export const useReviews = () => {
	const context = useContext(ReviewsContext);

	return context;
};

export default ReviewsProvider;
